export const SET_RESULTS = 'SET_RESULTS';
export const SET_URL_FILTERS = 'SET_URL_FILTERS';
export const SET_ACTIVE_DROPDOWN_FILTER = 'SET_ACTIVE_DROPDOWN_FILTER';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const ADD_RESULTS = 'ADD_RESULTS';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_MOBILE_FILTER_BAR_VISIBILITY = 'SET_MOBILE_FILTER_BAR_VISIBILITY';
